import {MOBILE_MODAL_WIDTH_THRESHOLD} from '@Components/modal';

export const isSmallScreenDropdown = (threshold = MOBILE_MODAL_WIDTH_THRESHOLD): boolean => {
  return window.innerWidth < threshold;
};
